// DS: i3.2
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '@wix/da-ds/pkg/Icons/IconWrap';
const AssetIcon = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#7579ff",
        d: "M2.336 4.71L8.18 1.334l5.844 3.374v6.748L8.18 14.83l-5.844-3.374z"
    }), /*#__PURE__*/ React.createElement("path", {
        opacity: ".1",
        d: "M8.178 1.335l5.844 3.374v6.748L8.178 14.83z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#7579ff",
        d: "M14.047 4.71L8.203 1.334 2.359 4.71l5.844 3.374z"
    }), /*#__PURE__*/ React.createElement("g", {
        fill: "#00e59b",
        transform: "matrix(.03034 0 0 .03034 .394 .271)"
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: "257.392",
        cy: "256.757",
        r: "27.51"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "257.392",
        cy: "35.078",
        r: "27.51"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "64.015",
        cy: "146.273",
        r: "27.51"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "447.986",
        cy: "146.273",
        r: "27.51"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "254.609",
        cy: "476.918",
        r: "27.51"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "447.986",
        cy: "365.728",
        r: "27.51"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "64.015",
        cy: "365.728",
        r: "27.51"
    })), /*#__PURE__*/ React.createElement("path", {
        d: "M14.253 10.336V5.738A1.065 1.065 0 1013.21 3.98l-2.457-1.403a.23.23 0 00-.313.086.23.23 0 00.085.313l2.45 1.398a1.06 1.06 0 00.002.675L8.937 7.38a1.062 1.062 0 00-1.596-.046L6.217 6.69a.23.23 0 00-.228.398l1.119.64a1.06 1.06 0 00-.053.331c0 .508.357.934.834 1.04v4.6c-.234.052-.439.18-.587.359l-3.978-2.297a1.058 1.058 0 00.077-.396c0-.508-.358-.934-.835-1.039v-4.58c.21-.046.398-.155.542-.306l2.057 1.177a.23.23 0 00.313-.085.23.23 0 00-.085-.313L3.345 5.048a1.06 1.06 0 00.056-.34c0-.111-.018-.219-.05-.32l4.06-2.343a1.062 1.062 0 001.55.037l.837.478a.23.23 0 00.313-.085.23.23 0 00-.086-.313l-.82-.468a1.059 1.059 0 00.062-.359 1.065 1.065 0 00-2.128 0c0 .108.016.212.046.31L3.122 3.991a1.065 1.065 0 10-1.014 1.757v4.58a1.065 1.065 0 10.957 1.815l4.025 2.323a1.063 1.063 0 00-.035.274 1.065 1.065 0 002.128 0c0-.073-.007-.143-.021-.21l4.11-2.374a1.065 1.065 0 10.981-1.82zM8.203.73A.606.606 0 118.2 1.942.606.606 0 018.203.73zM1.73 4.709a.606.606 0 111.212.001.606.606 0 01-1.212-.001zm.605 7.262a.606.606 0 11.002-1.211.606.606 0 01-.002 1.211zm11.649-7.868a.606.606 0 11-.001 1.212.606.606 0 01.001-1.212zM7.513 8.06a.606.606 0 111.212.002.606.606 0 01-1.212-.002zm.606 7.285a.606.606 0 11.001-1.212.606.606 0 01-.001 1.212zm.229-1.644V9.099a1.066 1.066 0 00.8-1.31l4.066-2.348c.153.16.354.273.58.314v4.564a1.066 1.066 0 00-.79 1.461l-4.03 2.328a1.066 1.066 0 00-.626-.407zm5.637-1.73a.606.606 0 11.001-1.211.606.606 0 01-.001 1.211z",
        fill: "#fff"
    })));
};
AssetIcon.displayName = 'AssetIcon';
export default AssetIcon;
